import { defineStore } from 'pinia';
import { directAxios, proxyAxios } from '@/utils/axios';

type AppLanguage = 'en' | 'zh'

export const useLanguageStore = defineStore('language', {
    state: (): {
        ip: string,
        country: string,
        language: AppLanguage,
        version: 0
    } => ({
        ip: '',
        country: 'CN',
        language: 'zh',
        version: 0
    }),

    actions: {
        async detectLanguage(): Promise<void> {
            try {
                // 1. 浏览器语言检测
                this.language = navigator.language.startsWith('zh') ? 'zh' : 'en'

                // 2. IP精确检测
                const ipResponse = await directAxios.get('https://api.ipify.org?format=json', {timeout: 1000})
                const { data } = await proxyAxios.get('/api/user/queryIp2Location',
                    { params: {ip: ipResponse.data.ip} }
                )

                // 3. 保存ip等信息
                this.ip = data.data.ip
                this.country = data.data.country.toUpperCase()
                this.language = data.data.country === 'CN' ? 'zh' : 'en'
            } catch (error) {
                // 如果报错的话，使用浏览器的地区和时区
                // 1. 获取浏览器语言（优先）或时区推断国家代码
                const language = navigator.language; // 如 "zh-CN"
                let country = language.split('-')[1]?.toUpperCase(); // 提取 "CN"

                // 2. 如果语言中无国家代码，尝试从时区推断
                if (!country) {
                    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // 如 "Asia/Shanghai"
                    country = timeZone.split('/')[0] === 'America'
                        ? 'US'
                        : timeZone.split('/')[1]?.slice(0, 2)?.toUpperCase();
                }

                this.country = country;
            }
        },
        setLanguage(userSelectedLanguage: AppLanguage): void {
            this.language = userSelectedLanguage
            this.version++;
            localStorage.setItem('language', userSelectedLanguage)
        }
    }
})